import configVars from '../assets/config.json';

import { environment as env_local } from './environment.local';
import { environment as env_dev } from './environment.dev';
import { environment as env_int } from './environment.int';
import { environment as env_stage } from './environment.stage';
import { environment as env_prod } from './environment.prod';

const _environments = {
  local: env_local,
  dev: env_dev,
  int: env_int,
  stage: env_stage,
  prod: env_prod,
};

type EnvironmentKey = keyof typeof _environments;

function detectEnv() {
  if (!configVars?.environment || (configVars?.environment == 'local' && !location.origin.includes('localhost'))) {
    //detect origin and choose appropriate environment
    console.log('determining environment from origin');
    const envKeys = Object.keys(_environments) as EnvironmentKey[];
    for (const x of envKeys) {
      if (_environments[x]?.origins.includes(location.origin)) {
        return x;
      }
    }
  } else {
    //return 'stage';
    if (configVars.environment in _environments) {
      return configVars.environment as EnvironmentKey;
    }
  }

  return 'local' as EnvironmentKey;
}

const detectedEnv = detectEnv();

// console.log('detectedEnv', detectedEnv);

export const environment = _environments[detectedEnv];
